{
  "title": "Create Bonfire",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Conjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a bonfire on ground that you can see within range. Until the spell ends, the bonfire fills a 5-foot cube. Any creature in the bonfire’s space when you cast the spell must succeed on a Dexterity saving throw or take 1d8 fire damage. A creature must also make the saving throw when it enters the bonfire’s space for the first time on a turn or ends its turn there.",
    "At Higher Levels. The spell’s damage increases by 1d8 when you reach 5th level (2d8), 11th level (3d8), and 17th level (4d8)."
  ],
  "spellLists": [
    "artificer",
    "druid",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
